













import { Component, Vue, Prop } from 'vue-property-decorator'
import firebase from '@/plugins/firebase'
import { User } from '@/models/user'
import AuthStore from '@/store/AuthStore'
import groupCollection from '@/models/group'

@Component({
  components: {}
})
export default class UserItemGroup extends Vue {
  @Prop({ type: Object, required: true }) doc!: firebase.firestore.QueryDocumentSnapshot<User>

  get item (): User {
    return this.doc.data()
  }

  get selectGroups (): { value: string, text: string }[] {
    return AuthStore.groups.map(doc => {
      return { value: doc.id, text: doc.data()?.name || '' }
    })
  }

  get groups (): string[] {
    return this.item.groups.map(doc => doc.id)
  }

  update (vals: string[]): void {
    const groups = vals.map(val => groupCollection.doc(val))
    this.doc.ref.set({ groups }, { merge: true })
  }
}
